import { Link } from 'react-router-dom';
import $ from 'jquery';
import PropTypes from 'prop-types';
import React from 'react';
import Globals from '../../utils/Globals';
import './css/style.scss';

class Document extends React.Component {
    static propTypes = {
        closeLink: PropTypes.string.isRequired,
        history: PropTypes.object.isRequired,
        children: PropTypes.any.isRequired
    };

    constructor(props) {
        super(props);
        this.state = {

        };

        if (Globals.user !== null) {
            this.user_name = Globals.user.get('firstname') + ' ' + Globals.user.get('lastname');
        }

        /*
        if(this.state.nextPath === undefined || this.state.nextPath === "") {
            this.setState({nextPath: Globals.nextPath});
        } */
    }

    componentWillUnmount() {
        if (document.getElementById('reportzeilen')) {
            document.getElementById('reportzeilen').style.display = 'block';
        }
    }

    onClose() {
        if (document.getElementById('reportzeilen')) {
            document.getElementById('reportzeilen').style.display = 'block';
        }
        if (this.props.closeLink && this.props.closeLink !== '') {
            this.props.history.push(this.props.closeLink);
        } else if (Globals.nextPath && Globals.nextPath !== '') {
            this.props.history.push(Globals.nextPath);
        } else {
            this.props.history.goBack();
        }
    }

    render() {
        return (
            <div id="documentHolder">
                <div id="documentHead">
                    <div id="documentTitle" />
                    <div id="studioInfo">
                        <div id="version">maBinso Studio {Globals.serverConfig.version} <Link to="/info">{$._('index.licence')}</Link></div>
                        <div id="username">{this.user_name}</div>
                    </div>
                    <a role="presentation" id="documentClose" onClick={this.onClose.bind(this)}>{$._('index.close')}</a>
                </div>
                <div id="documentContent">
                    <div id="documentPadding" />
                    <div id="documentContentInner">{this.props.children}</div>
                </div>
            </div>
        );
    }
}
export default Document;



// WEBPACK FOOTER //
// ./src/components/document/Document.js